import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Rating } from 'react-simple-star-rating';
import { Link } from 'react-router-dom';

const Feedback = () => {
    const [feedback, setFeedback] = useState([]);
    const [submitFeedback, setSubmitFeedback] = useState({
        outletId: 1,
        Recommantion: "",
        guestName: "",
        guestMobNo: "",
        ratings: [],
    });
    const API_BASE_URL = process.env.REACT_APP_API_KEY;
    // Fetch feedback master data
    const feedbackMasterApi = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}FeedBackMaster`);
            setFeedback(response.data);
        } catch (err) {
            console.error("Error fetching feedback data:", err);
        }
    };

    useEffect(() => {
        feedbackMasterApi();
    }, []);
   const cached = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
const storedData = cached.data || []; // get the actual array

let outletId, outletlogo;

if (Array.isArray(storedData) && storedData.length > 0) {
  outletId = storedData[0].outletId;
  outletlogo = storedData[0].outletlogo;
} else if (storedData && typeof storedData === "object") {
  outletId = storedData.outletId;
  outletlogo = storedData.outletlogo;
}


    // Handle rating change for specific feedback
    const handleRating = (FeedBackMasterId, FeedBackId, rate) => {
        setSubmitFeedback((prev) => {
            const existingRatingIndex = prev.ratings.findIndex(
                (item) => item.FeedBackMasterId === FeedBackMasterId && item.FeedBackId === FeedBackId
            );

            let updatedRatings = [...prev.ratings];
            if (existingRatingIndex > -1) {
                updatedRatings[existingRatingIndex].Marks = rate;
            } else {
                updatedRatings.push({ FeedBackMasterId, FeedBackId, Marks: rate });
            }

            return {
                ...prev,
                ratings: updatedRatings,
            };
        });
    };

    // Reset feedback form
    const handleReset = () => {
        setSubmitFeedback({
            feedBackRatingId: "",
            outletId: 1,
            Recommantion: "",
            guestName: "",
            guestMobNo: "",
            ratings: [],
        });
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubmitFeedback((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Submit feedback
    const feedbackSubmit = async () => {
        try {
            await axios.post(`${API_BASE_URL}FeedBackRating`, submitFeedback);
            alert("Feedback submitted successfully!");
            handleReset();
        } catch (error) {
            console.error("Error submitting feedback:", error);
            alert("Failed to submit feedback. Please try again.");
        }
    };

    return (
        <div className="container-fluid">
            <div className="col-md-12">
                <div className="row">
                    <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded p-0">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#">
                                <img
                                    src={outletlogo}
                                    alt=""
                                    width={60}
                                    height={40}
                                    className="d-inline-block align-text-center me-4 img-fluid"
                                />
                                <strong className="mt-5">Your Feedback Matters</strong>
                            </a>
                        </div>
                    </nav>
                    <div className="row d-flex align-items-center mt-3">
                        <div className="col-8">
                            <input
                                type="text"
                                name="guestName"
                                className="form-control"
                                placeholder="Enter Name"
                                value={submitFeedback.guestName}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-4 ">
                            <input
                                type="text"
                                name="guestMobNo"
                                className="form-control"
                                placeholder="Mobile No."
                                value={submitFeedback.guestMobNo}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="mt-2">
                        <table className="border border-2" style={{ width: "100%" }}>

                            <tbody className="border border-1">
                                {feedback.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {/* Render Feedback Type */}
                                        <tr className="border border-1">
                                            <td colSpan="2" className="border border-1">
                                                <b>{item.feedBackType}</b>
                                            </td>
                                        </tr>

                                        {/* Render Feedbacks */}
                                        {item.feedBacks.map((feedbackItem) => (
                                            <tr key={feedbackItem.feedBackId}>
                                                <td className="border border-1" style={{ width: "60%" }}>
                                                    <div style={{ marginLeft: "30px" }}>
                                                        {feedbackItem.feedBackName}
                                                    </div>
                                                </td>
                                                <td className="border border-1">
                                                    <Rating
                                                        onClick={(rate) => handleRating(item.feedBackMasterId, feedbackItem.feedBackId, rate)}
                                                        ratingValue={
                                                            submitFeedback.ratings.find(
                                                                (r) =>
                                                                    r.FeedBackMasterId === item.feedBackMasterId &&
                                                                    r.FeedBackId === feedbackItem.feedBackId
                                                            )?.Marks || 0
                                                        }
                                                        size={25}
                                                        label
                                                        transition
                                                        fillColor="orange"
                                                        emptyColor="gray"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        <div className="mt-1">
                            <div className="col-12">
                                <textarea
                                    type="text"
                                    name="Recommantion"
                                    className="form-control"
                                    placeholder="Anything not covered...."
                                    value={submitFeedback.Recommantion}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="row d-flex align-items-center mt-3">
                                <div className="col-6">
                                    <Link to="/Review">
                                        <button className='btn btn-info'>
                                            View Ratings
                                        </button>
                                    </Link>
                                </div>
                                <div className="col-6">
                                    <button
                                        className="btn btn-primary"
                                        style={{ marginLeft: "65px" }}
                                        onClick={feedbackSubmit}
                                    >
                                        Submit
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Feedback;
